import { AnalyticsService } from './AnalyticsService';
import { getAnalyticsConfig } from './config';

const config = getAnalyticsConfig('business');

const analyticsConfig = {
  enabled: config.enabled,
  debug: config.debug,
  appType: 'business' as const,
  providers: [
    {
      name: 'posthog',
      key: config.apiKey,
    },
  ],
};

export const analyticsService = new AnalyticsService(analyticsConfig);
export * from './types';
export * from './adapters/PostHogAdapter';
export * from './pageMapping';
